
import {jwtDecode, JwtPayload as DefaultJwtPayload} from 'jwt-decode';

interface JwtPayloadWithRole extends DefaultJwtPayload {
    role: string;
}

type role = 'Admin' | 'Facilitator';
const roles: role[] = ['Admin', 'Facilitator'];

export const checkUserRole = () => {
    const token = localStorage.getItem('panorama_token');
    if (!token) {
        return null;
    }
    try {
        const decodedToken = jwtDecode<JwtPayloadWithRole>(token);
        if (!roles.includes(decodedToken.role as role)) {
            console.error('Invalid role', decodedToken.role);
            return null;
        }
        return decodedToken.role;
    } catch (error) {
        console.error('Invalid token', error);
        return null;
    }
};